import axios from 'axios';

import {
  CustomPricing,
  CustomPricingInput,
  CustomPricingUpdate,
} from '../models/CustomPricing';

const getAll = async (carrierId: number) => {
  const { data } = await axios.get<CustomPricing[]>(
    `/carrier/${carrierId}/custom-pricing`
  );
  return data;
};

const create = async (carrierId: number, body: CustomPricingInput) => {
  const { data } = await axios.post<CustomPricing>(
    `/carrier/${carrierId}/custom-pricing`,
    body
  );
  return data;
};

const update = async (id: number, body: CustomPricingUpdate) => {
  const { data } = await axios.put<CustomPricing>(
    `/carrier/custom-pricing/${id}`,
    body
  );
  return data;
};

const remove = async (id: number) => {
  const { data } = await axios.delete(`/carrier/custom-pricing/${id}`);
  return data;
};

const apis = {
  create,
  getAll,
  remove,
  update,
};

export default apis;
